import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { externalProductPestPacName } from '@sales-center/common'

export const useGetBranchUrl = (id: string) => {
  const { externalProduct, clientUrl } = useSelector(selectCurrentUser)

  switch (externalProduct) {
    case externalProductPestPacName:
      return `${clientUrl}/branch/detail.asp?Mode=Edit&BranchID=${id}`
    default:
      return ''
  }
}
